query ParseDataFromWebsite($input: ParseDataFromWebsiteInput!) {
  parseDataFromWebsite(input: $input) {
    privacy
    imprint
  }
}
